import React, { useEffect, useState } from 'react'
import './huntplanner.scss'
// import BaseMapLogo from '../../../asset/HuntPlannerLogoWhite.png'
import BaseMapLogo from '../../../../asset/HuntPlannerLogoWhite.png'
import ReusableButton from '../reusableComponents/button/customButton'
import HuntplannerMainScreen from '../huntPlannerComponents/huntplannerMainScreen'
import { fetchHuntPlannerLayers } from '../../../action/huntplanner-state-Filter-actions'
import { connect } from 'react-redux'
import RightMenubar from '../huntPlannerComponents/huntPlanner-right-toolbar/rightMenubar'
import { huntPlannerRightMenuBarClose } from '../../../action/huntplanner-menu-bar'
import { showHideSubscriptionModal } from '../../../utils/subscriptionUtils'
import { huntPlannerRightMenuBarHide } from '../../../action/huntplanner-menu-bar'
import { startMapLoading } from '../../../action/huntplanner-map-loader'

import Loader from '../reusableComponents/loader/Loader'

const HuntPlannerLandingPage = (props) => {
    const [openHuntPlanner, setOpenHuntPlanner] = useState(false)
    let [loading, setLoading] = useState(false)
    let [upgraded, setUpgraded] = useState(false)

    let handleClick = () => {
        setOpenHuntPlanner(true)
        props.huntPlannerRightMenuBarHide()
        !props.huntMapLoader && props.startMapLoading()
    }

    let upgrade = (accessToken) => {
        showHideSubscriptionModal(accessToken)
    }

    useEffect(() => {
        filterExistingSubscription(props.user.userSubscription)

        props.huntPlannerRightMenuBarClose();

        // props.fetchHuntPlannerLayers((res) => {
        //     // console.log("API response received", res);
        // });

        // Ensure the loading state is set properly
        setLoading(true);

        const timer = setTimeout(() => {
            console.log("Timeout executed - Setting loading to false");
            setLoading(false);
        }, 500);

        return () => {
            console.log("Component Unmounted - Clearing timeout");
            clearTimeout(timer);
        };
    }, []);


    useEffect(() => {
        if (props.huntPlannerSelectedOtions.StateAbbreviation && props.huntPlannerSelectedOtions.Species && props.huntPlannerSelectedOtions.HuntTypeKey) {
            setLoading(false)
            setOpenHuntPlanner(true)
            !props.huntMapLoader && props.startMapLoading()
        }
    }, [props.huntPlannerSelectedOtions])

    let filterExistingSubscription = (object) => {
        let val = object.filter(item => {
            return item.subscriptionPlanId == 44 || item.subscriptionPlanId == 36
        })
        if (val.length > 0) {
            setUpgraded(true)
        } else {
            setUpgraded(false)
        }
    }


    return (
        <div className='hunt-planner-landing-page-container'>
            {loading &&
                <div className='hunt-planner-loading-container'>
                    <Loader></Loader>
                </div>
            }

            <img className='hunt-planner-logo' src={BaseMapLogo}></img>
            <p className='hunt-planner-landing-page-description'>Unit filtering, draw odds, harvest data, season dates</p>
            {
                <ReusableButton
                    className='lets-go-button lets-go-button-label'
                    label="LETS GO"
                    onClick={handleClick}
                    variant="primary"
                    size="small"
                    buttonWidth='236px'
                    buttonHeight="50px"
                />
            }

            {openHuntPlanner && <HuntplannerMainScreen></HuntplannerMainScreen>}

        </div>
    )
}

const mapStateToProps = state => ({
    selectedTabvalue: state.selectedTab,
    user: state.user,
    huntPlannerSelectedOtions: state.huntPlannerSelectedOtions,
    huntMapLoader: state.huntMapLoader
})

const mapDispatchToProps = dispatch => ({

    fetchHuntPlannerLayers: (cb) => dispatch(fetchHuntPlannerLayers(cb)),
    huntPlannerRightMenuBarClose: () => dispatch(huntPlannerRightMenuBarClose()),
    startMapLoading: () => dispatch(startMapLoading()),
    huntPlannerRightMenuBarHide: () => dispatch(huntPlannerRightMenuBarHide())
})


// export default TopMenu;
export default connect(mapStateToProps, mapDispatchToProps)(HuntPlannerLandingPage)


